import { bem, STREAMCARD_STATE } from '@socialive/common';
import PropTypes from 'prop-types';
import './guestUserLocation.css';

/*
#tailwind
guestUserLocation guestUserLocation--greenroom guestUserLocation--live guestUserLocation--backstage
*/

const GuestUserLocation = ({ context, testId, className, ...other }) => (
  <div className={bem`guestUserLocation--${{ [context]: true }} ${className}`} data-testid={testId} {...other}>
    {STREAMCARD_STATE[context]}
  </div>
);

GuestUserLocation.propTypes = {
  context: PropTypes.oneOf(['greenroom', 'live', 'backstage']),
  testId: PropTypes.string,
  className: PropTypes.string,
};

GuestUserLocation.defaultProps = {
  context: 'greenroom',
  testId: undefined,
  className: undefined,
};

export default GuestUserLocation;
